// src/components/layouts/app/header/DesktopHeader.tsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DesktopNav from "./DesktopNav";
import ProfileUserMenu from "./ProfileUserMenu";
import CartButton from "../../../../components/ui/elements/CartButton";
import FavoriteButton from "../../../../components/ui/elements/FavoriteButton";
import { getCartItemsCount } from "../../../../utils/storage";
import { getFavoritesCount } from "../../../../utils/favorites";

interface DesktopHeaderProps {
    onCartClick: () => void;
    onFavoritesClick: () => void;
    navItems: { path: string; label: string }[];
}

const DesktopHeader: React.FC<DesktopHeaderProps> = ({
    onCartClick,
    onFavoritesClick,
    navItems,
}) => {
    const [cartItemCount, setCartItemCount] = useState(0);
    const [favoriteCount, setFavoriteCount] = useState(0);

    // Rafraîchir les compteurs
    const refreshCounts = () => {
        setCartItemCount(getCartItemsCount());
        setFavoriteCount(getFavoritesCount());
    };

    useEffect(() => {
        refreshCounts();
        // Écouter les événements personnalisés
        window.addEventListener('cartUpdated', refreshCounts);
        window.addEventListener('favoritesUpdated', refreshCounts);
        return () => {
            window.removeEventListener('cartUpdated', refreshCounts);
            window.removeEventListener('favoritesUpdated', refreshCounts);
        };
    }, []);

    return (
        <div className="hidden md:flex items-center justify-between w-full">
            <Link to="/" className="flex items-center gap-2 shrink-0">
                <img src="/assets/logo/LogoBrainCreaWhite.png" alt="Braincrea" className="h-24 w-auto" />
            </Link>
            <DesktopNav items={navItems} />
            <div className="flex items-center gap-4">
                <CartButton cartItemCount={cartItemCount} onClick={onCartClick} />
                <FavoriteButton favoriteCount={favoriteCount} onClick={onFavoritesClick} />
                <ProfileUserMenu />
            </div>
        </div>
    );
};

export default DesktopHeader;